module.exports = __webpack_public_path__ + "img/Thailand-2.975d3ebd.jpg";